export const SET_KEYCLOAK = 'keycloak/SET_KEYCLOAK';
